import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../css/PricingSection.css";

const PricingSection = () => {
  const [pricingPlans, setPricingPlans] = useState([]);

  useEffect(() => {
    fetch("http://priyanthabandara.lk/getPricePlans.php")
      .then((res) => res.json())
      .then((data) => setPricingPlans(data))
      .catch((err) => console.error("Error loading pricing plans:", err));
  }, []);

  return (
    <div className="pricing-section">
      <h2>Photography Packages</h2>
      <div className="title-vis-line">
        <span className="vis-dot"></span>
        <span className="vis-line"></span>
        <span className="vis-dot"></span>
      </div>
      <p className="price-main-para">Choose a package that fits your needs</p>

      <div className="pricing-cards">
        {pricingPlans.map((plan, index) => (
          <div key={index} className={`pricing-card ${plan.popular ? "popular" : ""}`}>
            {plan.popular && <div className="badge">Most Popular</div>}
            <h3>{plan.title}</h3>
            <ul>
              {plan.features.map((feature, i) => (
                <li key={i}>{feature}</li>
              ))}
            </ul>
            <Link to="/contact">
              <button>Book Now</button>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PricingSection;
